<template>
	<img
		v-if="visible"
		class="official-tag"
		:class="'official-tag--' + size"
		:src="tagSrc"
		alt="官方人员"
		title="官方人员"
	/>
</template>

<script>
export default {
	name: "officialTag",
	props: {
		userTag: {
			type: [Number, String],
			default: 0
		},
		size: {
			type: String,
			default: "mini"
		}
	},
	data() {
		return {
			tagSrc: require("@/assets/image/official-tag.png")
		};
	},
	computed: {
		visible() {
			return Number(this.userTag) === 1;
		}
	}
};
</script>

<style scoped lang="scss">
.official-tag {
	display: inline-block;
	flex-shrink: 0;
	vertical-align: middle;
	object-fit: contain;
	pointer-events: none;
}

.official-tag--mini {
	height: 20px;
	width: auto;
}

.official-tag--small {
	height: 16px;
	width: auto;
	max-width: 54px;
}

.official-tag--medium {
	height: 22px;
	width: auto;
}

.official-tag--large {
	height: 40px;
	width: auto;
}
</style>
